export default "__VITE_ASSET__453a79bc__"